import React, { useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import { AuthContext } from '../../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const FacebookCallback = () => {

 const navigate = useNavigate();
 const { setUsuario } = useContext(AuthContext);
const hasRun = useRef(false); // 👈 esto actúa como flag
  useEffect(() => {
    if (hasRun.current) return; // si ya corrió, no vuelve a correr
    hasRun.current = true;

    const fetchFacebookData = async () => {
      const code = new URLSearchParams(window.location.search).get('code');
      if (!code) return console.error('No se encontró el código en la URL');


      const clientId = process.env.REACT_APP_FACEBOOK_CLIENTID;
      const clientSecret = process.env.REACT_APP_FACEBOOK_CLIENTSECRET;
      const redirectUri = process.env.REACT_APP_REDIRECT_FACEBOOK_URI;

      try {
        // Paso 1: Intercambiar el código por un token
        const tokenResponse = await axios.get('https://graph.facebook.com/v18.0/oauth/access_token', {
          params: {
            client_id: clientId,
            redirect_uri: redirectUri,
            client_secret: clientSecret,
            code,
          },
        });

        const accessToken = tokenResponse.data.access_token;

        // Paso 2: Obtener datos del usuario
        const userResponse = await axios.get('https://graph.facebook.com/me', {
          params: {
            access_token: accessToken,
            fields: 'id,name,email,picture',
          },
        });

        const { id, name, email, picture } = userResponse.data;

        const data = {
                
          peticion: 14, 
          param: {
            proveedor: 'facebook',
            id_proveedor: id,
            correo: email,
            nombre_completo: name,
            foto_perfil: picture?.data?.url,
            token_acceso: accessToken,
            token_refresh:  null,
            expira_en: null,
            scopes:  null,
            esLogin: 0
          }
        
       }
       try {
        const response = await fetch('https://estanciamargarita.com.ar/backendGama/php/servicios/serviciosUsuario.php', {
          method: 'POST',
          headers: new Headers(), // no incluimos Content-Type para evitar preflight
          body: JSON.stringify(data),
        });
      
        const result = await response.json();
      
        if (result) {
          setUsuario(result.data)
          localStorage.setItem('usuario', JSON.stringify(result.data));
           toast.success(`Hola bienvenido ${result.data.nombre_completo} 👋`, {
                duration: 4000,
                position: "top-center",
              });
          navigate('/reserva'); // o donde quieras redirigirlo
        }
      } catch (error) {
        console.error("Error en el intercambio de tokens:", error);
      }


      } catch (error) {
        console.error('Error al procesar el callback de Facebook:', error);
        navigate('/auth/login'); // o donde quieras redirigirlo
      }
    };

    fetchFacebookData();
  }, []);

  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-lg">Procesando autenticación con Facebook...</p>
    </div>
  );
};

export default FacebookCallback;
